<template>
	<div class="white-bg">
		<transition name="fade">
			<div v-if="loading" id="preloader">
				<div id="status"></div>
			</div>
		</transition>
		<default-header :name="fullName" @logout="logout"/>
		<slot/>
		<default-footer/>
	</div>
</template>

<style lang="less">
	.fade-enter-active, .fade-leave-active {
		transition: opacity .95s;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>

<script>
import defaultHeader from '@/components/layout/default/header.vue';
import defaultFooter from '@/components/layout/default/footer.vue';
import { mapGetters } from 'vuex';

export default {
	components: { defaultHeader, defaultFooter },
	created() {
		this.runLoader();
	},
	data() {
		return {
			loading: false
		};
	},
	computed: {
		...mapGetters({ user: 'user' }),
		fullName() {
			return `${this.user.first_name} ${this.user.last_name}`;
		}
	},
	methods: {
		async logout() {
			try {
				await this.$store.dispatch('logout');
			} catch (e) {
				throw new Error(e);
			}
		},
		runLoader() {
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		}
	}
};
</script>
